var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
          attrs: {
            title: _vm.title,
            "close-on-click-modal": false,
            visible: _vm.visible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "inputForm",
              class: _vm.method === "view" ? "readonly" : "",
              attrs: {
                model: _vm.inputForm,
                size: "small",
                disabled: _vm.method === "view",
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 15 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "浮点数字",
                            prop: "num",
                            rules: [
                              {
                                required: true,
                                message: "浮点数字不能为空",
                                trigger: "blur",
                              },
                              {
                                validator: _vm.validator.isFloat,
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请填写浮点数字",
                              max: "69.3",
                              min: "20.1",
                            },
                            model: {
                              value: _vm.inputForm.num,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "num", $$v)
                              },
                              expression: "inputForm.num",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "整数",
                            prop: "num2",
                            rules: [
                              {
                                required: true,
                                message: "整数不能为空",
                                trigger: "blur",
                              },
                              {
                                validator: _vm.validator.isDigits,
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请填写整数",
                              max: "30",
                              min: "10",
                            },
                            model: {
                              value: _vm.inputForm.num2,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "num2", $$v)
                              },
                              expression: "inputForm.num2",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "字符串",
                            prop: "str",
                            rules: [
                              {
                                required: true,
                                message: "字符串不能为空",
                                trigger: "blur",
                              },
                              {
                                min: 5,
                                message: "最小长度是5个字符",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请填写字符串",
                              maxlength: "65",
                              minlength: "5",
                            },
                            model: {
                              value: _vm.inputForm.str,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "str", $$v)
                              },
                              expression: "inputForm.str",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "邮件",
                            prop: "email",
                            rules: [
                              {
                                required: true,
                                message: "邮件不能为空",
                                trigger: "blur",
                              },
                              {
                                min: 10,
                                message: "最小长度是10个字符",
                                trigger: "blur",
                              },
                              {
                                validator: _vm.validator.isEmail,
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请填写邮件",
                              maxlength: "60",
                              minlength: "10",
                            },
                            model: {
                              value: _vm.inputForm.email,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "email", $$v)
                              },
                              expression: "inputForm.email",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "网址",
                            prop: "url",
                            rules: [
                              {
                                required: true,
                                message: "网址不能为空",
                                trigger: "blur",
                              },
                              {
                                min: 10,
                                message: "最小长度是10个字符",
                                trigger: "blur",
                              },
                              {
                                validator: _vm.validator.isURL,
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请填写网址",
                              maxlength: "30",
                              minlength: "10",
                            },
                            model: {
                              value: _vm.inputForm.url,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "url", $$v)
                              },
                              expression: "inputForm.url",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "日期",
                            prop: "newDate",
                            rules: [
                              {
                                required: true,
                                message: "日期不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              placeholder: "选择日期时间",
                            },
                            model: {
                              value: _vm.inputForm.newDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "newDate", $$v)
                              },
                              expression: "inputForm.newDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "备注信息",
                            prop: "remarks",
                            rules: [
                              {
                                required: true,
                                message: "备注信息不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              placeholder: "请填写备注信息",
                            },
                            model: {
                              value: _vm.inputForm.remarks,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "remarks", $$v)
                              },
                              expression: "inputForm.remarks",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "浮点数小于等于0",
                            prop: "c1",
                            rules: [
                              {
                                required: true,
                                message: "浮点数小于等于0不能为空",
                                trigger: "blur",
                              },
                              {
                                validator: _vm.validator.isFloatLteZero,
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写浮点数小于等于0" },
                            model: {
                              value: _vm.inputForm.c1,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "c1", $$v)
                              },
                              expression: "inputForm.c1",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "身份证号码",
                            prop: "c2",
                            rules: [
                              {
                                required: true,
                                message: "身份证号码不能为空",
                                trigger: "blur",
                              },
                              {
                                validator: _vm.validator.isCardId,
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写身份证号码" },
                            model: {
                              value: _vm.inputForm.c2,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "c2", $$v)
                              },
                              expression: "inputForm.c2",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "QQ号码",
                            prop: "c3",
                            rules: [
                              {
                                required: true,
                                message: "QQ号码不能为空",
                                trigger: "blur",
                              },
                              {
                                validator: _vm.validator.isQq,
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写QQ号码" },
                            model: {
                              value: _vm.inputForm.c3,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "c3", $$v)
                              },
                              expression: "inputForm.c3",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "手机号码",
                            prop: "c4",
                            rules: [
                              {
                                required: true,
                                message: "手机号码不能为空",
                                trigger: "blur",
                              },
                              {
                                validator: _vm.validator.isMobile,
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写手机号码" },
                            model: {
                              value: _vm.inputForm.c4,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "c4", $$v)
                              },
                              expression: "inputForm.c4",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "中英文数字下划线",
                            prop: "c5",
                            rules: [
                              {
                                required: true,
                                message: "中英文数字下划线不能为空",
                                trigger: "blur",
                              },
                              {
                                validator: _vm.validator.stringCheck,
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写中英文数字下划线" },
                            model: {
                              value: _vm.inputForm.c5,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "c5", $$v)
                              },
                              expression: "inputForm.c5",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "合法字符(a-z A-Z 0-9)",
                            prop: "c6",
                            rules: [
                              {
                                required: true,
                                message: "合法字符(a-z A-Z 0-9)不能为空",
                                trigger: "blur",
                              },
                              {
                                validator: _vm.validator.isRightfulString,
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请填写合法字符(a-z A-Z 0-9)",
                            },
                            model: {
                              value: _vm.inputForm.c6,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "c6", $$v)
                              },
                              expression: "inputForm.c6",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "英语",
                            prop: "en",
                            rules: [
                              {
                                validator: _vm.validator.isEnglish,
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写英语" },
                            model: {
                              value: _vm.inputForm.en,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "en", $$v)
                              },
                              expression: "inputForm.en",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "汉字",
                            prop: "zn",
                            rules: [
                              {
                                validator: _vm.validator.isChinese,
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写汉字" },
                            model: {
                              value: _vm.inputForm.zn,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "zn", $$v)
                              },
                              expression: "inputForm.zn",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "汉英字符",
                            prop: "enzn",
                            rules: [
                              {
                                validator: _vm.validator.isChineseChar,
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写汉英字符" },
                            model: {
                              value: _vm.inputForm.enzn,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "enzn", $$v)
                              },
                              expression: "inputForm.enzn",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
              _vm.method != "view"
                ? _c(
                    "el-button",
                    {
                      directives: [
                        { name: "noMoreClick", rawName: "v-noMoreClick" },
                      ],
                      attrs: { size: "small", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.doSubmit()
                        },
                      },
                    },
                    [_vm._v("确定")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }